import './services.local-datetime';
import './services.product-stock';
import { chunk } from 'lodash-es';
import { getAvailablePlatform } from '../../utils/promotion';
import { AVAILABLE_PLATFORM_KEY } from '../../shop/constants/promotion';
import { getProductByIds } from '../../service/productService';

const GIFT_INFO_MODAL_ID = 'promotion-gift-info';

app.controller('PromotionPageController', [
  '$scope',
  '$rootScope',
  '$filter',
  '$uibModal',
  '$timeout',
  'mainConfig',
  'localDatetimeServices',
  'promotion',
  function (
    $scope,
    $rootScope,
    $filter,
    $uibModal,
    $timeout,
    mainConfig,
    localDatetimeServices,
    promotion,
  ) {
    var dateStringFormat = 'YYYY/MM/DD HH:mm';
    var specificDateStringFormat = 'HH:mm DD/MM/YYYY';
    $scope.promotion = promotion;
    $scope.getFormattedDateString = function (i18nKey, date) {
      if (!date) return '';

      return $filter('translate')(i18nKey, {
        date: dayjs(date).format(
          mainConfig.localeData.loadedLanguage.code === 'vi'
            ? specificDateStringFormat
            : dateStringFormat,
        ),
      });
    };

    $scope.isBundleGroupDiscountType = [
      'bundle_group',
      'bundle_group_gift',
      'bundle_group_amount',
      'bundle_group_percentage',
    ].includes(promotion.discount_type);

    $scope.isGiftPromotion = [
      'gift',
      'bundle_gift',
      'bundle_group_gift',
    ].includes(promotion.discount_type);

    $scope.getPromotionSummary = function () {
      const loadedLanguage = mainConfig.localeData.loadedLanguage.code;
      return promotion.summary[loadedLanguage] || '';
    };

    $scope.hasMultiTier = function () {
      return promotion.extend_promotions?.length > 0;
    };

    $scope.openGiftInfoModal = function () {
      const $modal = document.querySelector(
        `sl-modal[sl-modal-id="${GIFT_INFO_MODAL_ID}"]`,
      );
      const $el = document.querySelector('promotion-gift-info');
      if (!$modal || !$el) return;

      if (typeof $modal.onShow === 'function') {
        $modal.onShow();
      }
      $el.dataset.loading = 'true';
      $el.dataset.error = '';

      const tierPromotions = [promotion].concat(
        promotion.extend_promotions || [],
      );
      const uniqueIds = Array.from(
        new Set(
          tierPromotions.flatMap((tier) => tier.discountable_product_ids || []),
        ),
      );

      // Backend limits product_ids to 1~10 per request, so chunk and fan out.
      const PRODUCT_IDS_CHUNK_SIZE = 10;
      const chunks = chunk(uniqueIds, PRODUCT_IDS_CHUNK_SIZE);

      Promise.all(
        chunks.map((ids) =>
          getProductByIds({
            product_ids: ids,
            include_modules: ['agg'],
            req_source: 'promotion',
          }),
        ),
      )
        .then((responses) => {
          const productsMap = new Map(
            responses.flatMap((res) => {
              const products = res?.data?.product_infos ?? [];
              return products.map((product) => [product.product_id, product]);
            }),
          );
          const tiersInfo = tierPromotions.map((tier) => {
            const tierGifts = (tier.discountable_product_ids || [])
              .map((id) => productsMap.get(id))
              .filter(Boolean);
            const allSoldOut =
              tierGifts.length > 0 && tierGifts.every((gift) => gift.sold_out);
            return {
              tier_summary: $filter('translateModel')(tier.tier_summary),
              all_sold_out: allSoldOut,
              gifts: tierGifts,
            };
          });
          $el.dataset.tiers = JSON.stringify(tiersInfo);
          $el.dataset.loading = 'false';
        })
        .catch((err) => {
          $el.dataset.error = (err && err.message) || 'fetch_failed';
          $el.dataset.loading = 'false';
        });
    };

    $scope.showTermModal = function (termText) {
      $rootScope.currentModal = $uibModal.open({
        templateUrl: require('../../../../../public/themes/v1/default/views/templates.dialog.promotion-term.html'),
        controller: [
          '$scope',
          '$filter',
          '$uibModalInstance',
          function ($scope, $filter, $uibModalInstance) {
            if (!termText)
              termText = $filter('translate')('promotions.page.term.default');
            $scope.termText = termText.replace(/\n/g, '<br>');

            $scope.confirm = function () {
              $uibModalInstance.close();
            };

            $timeout(function () {
              $('.promotion-term-dialog .scroll-area').overlayScrollbars({
                overflowBehavior: { x: 'hidden' },
              });

              $('.promotion-term-modal-backdrop').one('click', function () {
                $uibModalInstance.dismiss('cancel');
              });
            });
          },
        ],
        windowClass: 'promotion-term-modal-window',
        backdropClass: 'promotion-term-modal-backdrop',
      });
      $rootScope.currentModal.opened = $rootScope.currentModal.opened.then(
        function () {
          $rootScope.$emit('modal.open');
        },
      );
    };

    $timeout(function () {
      var $dateDOM = $('.PromotionPage-container .local-datetime');
      var offset = new Date().getTimezoneOffset() / -60;
      var title = $filter('translate')(
        'promotions.page.display_local_timezone',
        {
          offset: offset < 0 ? offset : '+' + Math.abs(offset),
        },
      );

      localDatetimeServices.mountTooltip($dateDOM, title);
    });

    $('.js-show-term-button').on('click', function () {
      $scope.showTermModal(this.dataset.promotionTerm);
    });

    $scope.availablePlatform = getAvailablePlatform(promotion);
    const availablePlatformsString = $scope.availablePlatform
      .map((platform) => $filter('translate')(AVAILABLE_PLATFORM_KEY[platform]))
      .join('/');

    $scope.getFirstPurchaseOnlyText = () =>
      promotion?.first_purchase_all_platform
        ? $filter('translate')('promotions.page.first_purchase_only')
        : $filter('translate')(
            'promotions.page.first_purchase_only.with_platform',
            {
              platform: availablePlatformsString,
            },
          );

    $scope.showSelectedRetail = function () {
      if (!promotion?.available_channels) return;
      $uibModal.open({
        templateUrl: require('../../../../../public/themes/v1/default/views/users/templates.dialog.coupon_selected_retail_store.html'),
        controller: [
          '$scope',
          '$uibModalInstance',
          function ($modalScope, $uibModalInstance) {
            $modalScope.availableChannels = promotion.available_channels
              .map((channel) => $filter('translateModel')(channel.name))
              .join(', ');
            $modalScope.confirm = function () {
              $uibModalInstance.close();
            };
          },
        ],
      });
    };
  },
]);
